// src/firebaseConfig.js
import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';

const firebaseConfig = {
  apiKey: "AIzaSyCO0QZdpKvppX63EIKxjjKdOFPIZP2HkYU",
  authDomain: "monotest-d5389.firebaseapp.com",
  databaseURL: "https://monotest-d5389-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "monotest-d5389",
  storageBucket: "monotest-d5389.firebasestorage.app",
  messagingSenderId: "600450774686",
  appId: "1:600450774686:web:d66e92c47eb7d393bcad8f",
  measurementId: "G-H6HTNCKXS2"
};

// Инициализация Firebase
const app = initializeApp(firebaseConfig);

// Экспорт базы данных
export const database = getDatabase(app);
